import { VoiceNotEnabledException } from '@amzn/ihm-associate-tools-js-lib'

export const verifyVoiceIsEnabled = () => {
    // Default to false (disabled) to match original WeblabService behavior on error
    const isEnabled = false
    if (!isEnabled) {
        return Promise.reject(new VoiceNotEnabledException({
            message: 'Voice is not enabled for store/user',
        }))
    }
    return Promise.resolve()
}
